import { gql } from "@apollo/client";

export const CONTENT_NODE_FIELDS = gql`
    fragment ContentNodeFields on ContentNode {
        id
        type
        sizeInTokens
        metadata
        isPromptable
        isViewable
        associatedOfficialDocument {
            id
            reference
            amendsDocumentId
            name
            metadata
            hoverTitle
            jurisdiction
        }
    }
`; 